<template>
  <div>
    <SkeletonScreen v-if="!isCloseSkeletonScreen" :data="3" />
    <div v-if="isCloseSkeletonScreen">
      <div v-if="pageType !== 'user'">
        <app-live-list-pub
          v-if="msg_list.length"
          v-for="(item,index) in msg_list"
          :key="index"
          :live="userInfo"
          :msg="item"
        ></app-live-list-pub>
      </div>
      <div v-if="pageType === 'user'">
        <app-user-live-list-pub
          v-if="msg_list.length"
          v-for="(item,index) in msg_list"
          :key="index"
          :live="userInfo"
          :msg="item"
        ></app-user-live-list-pub>
      </div>
      <no-result v-if="!msg_list.length" title="此用户没有发布内容"></no-result>
      <loading
        class="loadbox"
        style="padding: 12px 0;"
        loadType="small"
        :title="'正在加载中...'"
        v-if="listLoading"
      ></loading>
      <no-data msg="已经到底了~" v-if="!listLoading&&hasMore&&msg_list.length"></no-data>
    </div>
  </div>
</template>
<script>
import UserProfilesApi from "@/api/userProfiles/";
import appLiveListPub from "@/components/appLiveListPub/";
import appUserLiveListPub from '@/components/liveListPub/UserIndex';
import noResult from "@/base/no-result/";
import noData from "@/base/nodata/";

export default {
  name: "UserProfiles",
  components: {
    appLiveListPub,
    appUserLiveListPub,
    noData,
    noResult
  },
  props: {
    pageType: {
      type: String,
      default: "teacher"
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userProfiles.userInfo;
    }
  },
  data() {
    return {
      user_id: parseInt(this.$route.params.id),
      isCloseSkeletonScreen: false,
      msg_list: [],
      before: "",
      hasMore: false,
      listLoading: true,
      randomStr: Math.random()
        .toString(36)
        .slice(-4)
    };
  },
  created() {
    this.getUserCenterList();
  },
  methods: {
    columnListMore() {
      if (this.msg_list.length && this.hasMore) return;
      this.hasMore = true;
      this.before = this.msg_list.length ? this.msg_list[this.msg_list.length - 1].rec_time : ''
			this.getUserCenterList();
    },

    //获取用户个人主页全部直播列表
    async getUserCenterList() {
      let data = await UserProfilesApi.getUserCenterList(
        this.user_id,
        this.before
      );
      this.$share(data.share);
      data.list.map(item => {
        item.forward_info = item.origin;
      });
      if (this.before) {
        this.msg_list = this.msg_list.concat(data.list);
      } else {
        this.msg_list = data.list;
      }
      this.isCloseSkeletonScreen = true;
      this.$emit("scrollRefresh");
      this.isData(data.list);
    },
    isData(data) {
      if (!data.length) {
        this.listLoading = false;
        this.hasMore = true;
      } else {
        this.hasMore = false;
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@color-red: #fe484a; //主色
@color-red-high: #c7000a; //特殊情况
@color-green: #0ac890; //主色
@color-blue: #1d88d0; //全文、超链接颜色
@color-gray-small: #f7f7f7; //转发内容背影色

@color-gray-high: #222222;
@color-gray-middle: #636363;
@color-gray-low: #939393;

.border-1px(@color: #ccc, @radius: 0px, @style: solid) {
  position: relative;

  &::after {
    content: "";
    pointer-events: none;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: 0 0;
    border-bottom: 1px @style @color;
    border-radius: @radius;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    @media (min-resolution: 2dppx) {
      width: 200%;
      height: 200%;
      border-radius: @radius * 2;
      transform: scale(0.5);
    }

    @media (min-resolution: 3dppx) {
      width: 300%;
      height: 300%;
      border-radius: @radius * 3;
      transform: scale(0.333);
    }
  }
}

.recommend {
  position: fixed;
  overflow: auto;
  top: 48px;
  width: 100%;
  padding-bottom: 50px;
  bottom: 0;
  background-color: #f0f0f0;
}

.recommend-content {
  height: 100%;
  overflow: hidden;
}
</style>